import React, { FC, ReactNode } from 'react';
import { CustomTooltip } from '@components/CustomTooltip';
import { ListItemProps } from '@components/Inputs/Autocomplete/types';
import { useTruncatedWithCount } from '@hooks/useTruncatedWithCount';
import { Checkbox, MenuItem, Typography } from '@mui/material';

type Props = ListItemProps & {
  renderTooltipTitle?: (option: any & { label: string }) => ReactNode;
  endAdornment?: ReactNode;
};

const ListItemWithTooltip: FC<Props> = ({
  props: { className, ...props },
  option,
  state: { selected },
  multiple,
  renderTooltipTitle,
  endAdornment,
}) => {
  const { textRef, isTruncated } = useTruncatedWithCount<HTMLElement>(
    option.label,
  );

  return (
    <CustomTooltip
      placement="left"
      title={renderTooltipTitle ? renderTooltipTitle(option) : option.label}
      disableHoverListener={!isTruncated}
      sx={{
        textAlign: 'center',
        width: '180px',

        '& .MuiTypography-root': { lineHeight: '16px' },
      }}
    >
      <MenuItem
        component="li"
        className={className}
        sx={{ color: selected ? 'grey.1000' : 'grey.900', gap: 2 }}
        {...props}
      >
        {multiple && <Checkbox checked={selected} />}

        <Typography
          ref={textRef}
          variant="body1"
          color="inherit"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            minWidth: 0,
          }}
        >
          {option.label}
        </Typography>

        {endAdornment}
      </MenuItem>
    </CustomTooltip>
  );
};

export default ListItemWithTooltip;
